import React from "react";
import CustomTable from "../../Shared/Table/index";
import { Table } from "./style";

const fakeData = [
  {
    name: "John Doe",
    recent_application: "12/12/1990",
    date_saved: "12/12/1990",
  },
  {
    name: "John Doe",
    recent_application: "12/12/1990",
    date_saved: "12/12/1990",
  },
  {
    name: "John Doe",
    recent_application: "12/12/1990",
    date_saved: "12/12/1990",
  },
];

const tableHeaders = [
  { name: "Name", class: "" },
  { name: "Most Recent Application", class: "hidden-xs" },
  { name: "Date Saved", class: "" },
];

const fields = [
  { name: "name", class: "" },
  { name: "recent_application", class: "" },
  { name: "date_saved", class: "" },
];

const Applicants = ({ styles }) => (
  <Table style={styles}>
    <h2>Applicants</h2>
    <CustomTable
      tableHeaders={tableHeaders}
      tableData={fakeData}
      fields={fields}
      hideFieldsXs={["recent_application"]}
      remove
      onRemove={() => {}}
    />
  </Table>
);

export default Applicants;
